import { MONTHS, TOTAL, LATEST, CURRENT_YEAR } from "../constants";

const createDateFromPeriod = (period) => {
	const date = {
		year: CURRENT_YEAR,
		month: null,
		day: null,
	};

	const parsed = period
		.split("-")
		.map((value) => parseInt(value, 10))
		.filter((value) => typeof value === "number");

	const isValidDateInput = (year, month, day) => {
		let normalized = month;

		if (month != null && !Number.isNaN(month)) {
			normalized -= 1;
		}

		return !Number.isNaN(new Date(year, normalized, day).getTime());
	};

	if (period === LATEST) {
		return {
			date,
			year: CURRENT_YEAR,
			period,
		};
	}

	if (period === TOTAL) {
		date.year = null;
		return {
			date,
			year: TOTAL,
			period: null,
		};
	}

	if (parsed.length === 0) {
		return {
			date,
			year: CURRENT_YEAR,
			period: LATEST,
		};
	}

	switch (parsed.length) {
		case 1: {
			date.day = null;
			date.month = null;
			date.year = parsed[0];
			break;
		}
		case 2: {
			date.day = null;
			date.month = parsed[0] - 1;
			date.monthText = MONTHS[parsed[0] - 1].number;
			date.year = parsed[1];
			break;
		}
		case 3: {
			date.day = parsed[0];
			date.month = parsed[1] - 1;
			date.year = parsed[2];
			break;
		}
	}

	if (!isValidDateInput(date.year, date.month, date.day)) {
		return {
			date: {
				day: null,
				month: null,
				year: CURRENT_YEAR,
			},
			year: CURRENT_YEAR,
			period: LATEST,
		};
	}

	return {
		date,
		year: null,
		period: null,
	};
};

export default createDateFromPeriod;
